import { Link } from 'react-router-dom'

import { useFinding } from '../api/queries'
import { Failure } from './Failure'
import { Severity } from './Severity'

/**
 * The alert under the cursor, beside the queue.
 *
 * It exists so that deciding "is this worth opening" does not cost the analyst their
 * place in the list. Everything here is a summary — the full story is one keystroke
 * away, and duplicating it would make this panel a second investigation screen that
 * drifts from the first.
 */
export function Preview({ id }: { id: string | undefined }) {
  const query = useFinding(id)

  if (!id) return <p className="muted">Nothing selected.</p>
  if (query.isError) return <Failure error={query.error} onRetry={() => query.refetch()} />
  if (!query.data) return <p className="muted">Loading…</p>

  const finding = query.data
  const evidence = finding.ocsf.evidences?.[0]

  return (
    <div className="panel" style={{ maxHeight: '60vh', overflow: 'auto' }}>
      <div style={{ display: 'flex', gap: 'var(--space-2)', alignItems: 'center' }}>
        <Severity id={finding.severity_id} />
        <strong>{finding.rule_title}</strong>
      </div>
      <p className="mono muted">
        {finding.hostname} · {new Date(finding.last_seen).toLocaleString()}
      </p>
      <p>{finding.ocsf.finding_info?.desc}</p>
      {evidence && (
        <pre className="mono" style={{ whiteSpace: 'pre-wrap' }}>
          {evidence.raw_data}
        </pre>
      )}
      <p className="muted">{finding.ocsf.remediation?.desc}</p>
      <Link to={`/findings/${finding.id}`}>Open the full story →</Link>
    </div>
  )
}
